export const WorkerEmbeddedPages = {
  DashboardWorker: "dashboard-worker",
  ProfileWorker: "profile-worker",
} as const;

export type WorkerEmbeddedPage =
  (typeof WorkerEmbeddedPages)[keyof typeof WorkerEmbeddedPages];

export const CompanyEmbeddedPages = {
  Dashboard: "dashboard",
  Employees: "employees",
  Contractors: "contractors",
  CustomAttributes: "custom-attributes",
  CustomPaperwork: "custom-paperwork",
  I9: "i9",
  Reports: "reports",
} as const;

export type CompanyEmbeddedPage =
  (typeof CompanyEmbeddedPages)[keyof typeof CompanyEmbeddedPages];
